import ApiService from "@/core/services/ApiService";

class TramiteService {

    public static Save(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/tramite/save', data)
    }

    public static Edit(data: any) {
        ApiService.setHeader()
        return ApiService.get('api/tramite/edit', data)
    }

    public static List(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/tramite/list', data)
    }

    public static History(id:any){
        ApiService.setHeader()
        return ApiService.get('api/tramite/history', id)
    }

    //Atender trámite
    public static Attend(data: any){
        ApiService.setHeader()
        return ApiService.post('api/tramite/attend', data)
    }

    public static Files(data: any){
        ApiService.setHeader()
        return ApiService.post('api/tramite/files', data)
    }
    
}

export default TramiteService;